
import { Component, Vue } from 'vue-property-decorator';
import RoomList from './room-list/index.vue';
import GameRoomList from './game-room-manage/index.vue';
import ConfigLevel from './components/config.vue';
import { getRoomConfigSetting, updateRoomConfigOpen, updateRoomConfigIdentify } from '@/api/room-manage';
import { toast } from '@/utils/common';

@Component({
  components: { RoomList, GameRoomList, ConfigLevel },
})
export default class extends Vue {
  private is_open: boolean = false;
  private is_identify_open: boolean = false;
  private configDialogVisiable: boolean = false;

  activeName = 'first';
  // handleClick(tab: string) {
  //   console.log(tab, 'tab');

  //   this.activeName = tab;
  // }
  async getList() {
    try {
      const res = await getRoomConfigSetting();
      const { is_open, is_identify_open } = res.data;
      this.is_open = is_open;
      this.is_identify_open = is_identify_open;
    } catch (err) {
      console.log(err);
    }
  }
  async handleConfig(type: string) {
    try {
      let res;
      if (type === 'is_open') {
        res = await updateRoomConfigOpen({ open: this.is_open });
      } else {
        res = await updateRoomConfigIdentify({ open: this.is_identify_open });
      }
      if (res.code == 0) {
        toast('操作成功！');
      } else {
        toast(res.msg);
      }
    } catch (err) {
      console.log(err);
    }
  }
  mounted() {
    if (this.$route.params && this.$route.params.type) {
      this.activeName = this.$route.params.type;
    }
    this.getList();
  }
}
